import timeless1 from '../images/TimelesSound/timelesssound_HackRPI2025.png';
import modern from '../images/TimelesSound/modern.png';
import retro from '../images/TimelesSound/retro.png';
import modernSound from '../images/TimelesSound/Modernsound.png';
import retroSound from '../images/TimelesSound/Retrosound.png';
import Meridian1 from '../images/Meridian/Meridian_Homepage.png';
import Comedyfued1 from '../images/ComedyFeud/ComedyFeud.png';
import Comedyfued2 from '../images/ComedyFeud/ComedyFeud2.png';
import Comedyfued3 from '../images/ComedyFeud/ComedyFeud3.png';
import Comedyfued4 from '../images/ComedyFeud/ComedyFeud4.png';
import Comedyfued5 from '../images/ComedyFeud/ComedyFeud5.png';
import Urban1 from '../images/UrbanVoice/UrbanVoice.png';
import Urban2 from '../images/UrbanVoice/UrbanVoice2.png';
import Urban3 from '../images/UrbanVoice/UrbanVoice3.png';
import Urban4 from '../images/UrbanVoice/UrbanVoice4.png';
import Urban5 from '../images/UrbanVoice/UrbanVoice5.png';
import Urban6 from '../images/UrbanVoice/UrbanVoice6.png';
import Urban7 from '../images/UrbanVoice/UrbanVoice7.png';
import Urban8 from '../images/UrbanVoice/UrbanVoice8.png';
import choose1 from '../images/Adventure/Chooseyourownadventure.png'; 
import choose2 from '../images/Adventure/Choose2.png';
import choose3 from '../images/Adventure/Choose3.png';
import choose4 from '../images/Adventure/Choose4.png';
import choose5 from '../images/Adventure/Choose5.png';
import choose6 from '../images/Adventure/Choose6.png';
import choose7 from '../images/Adventure/Choose7.png';
import budget1 from '../images/BudgetScout/BudgetScout.png'; 
import catalog1 from '../images/BudgetScout/catalog.png';
import homepage from '../images/BudgetScout/homepage.png';
import recording from '../images/BudgetScout/recording.mp4';


export const projects = [
  {
    slug: "timeless-sound",
    title: "Timeless Sound",
    tag: "HackRPI 2025",
    thumbnail: timeless1,
    description: "A music player that lets you slide between retro and modern UI skins in real time — same player, two eras of design.",
    techStack: ["React 18", "React Router DOM", "Create React App", "pnpm", "Vercel"],
    liveUrl: "https://timelesssound.vercel.app",
    githubUrl: "https://github.com/SujiChen/timeless_sound",
    photos: [timeless1, modern, retro, modernSound, retroSound],
  },
  {
    slug: "project-meridian",
    title: "Project Meridian",
    tag: "RCOS 2024–2026",
    thumbnail: Meridian1,
    description: "A campus events & organizations dashboard that surfaces what's happening today and recommends groups worth joining.",
    techStack: [],
    liveUrl: "https://rpi.meridian.study/events-dashboard",
    githubUrl: "https://github.com/himekatie/meridian",
    photos: [Meridian1],
  },
  {
    slug: "upac-family-feud",
    title: "UPAC Family Feud Website",
    tag: "Club Event 2025",
    thumbnail: Comedyfued1,
    description: "A live, browser-based Family Feud board built for UPAC's comedy event - buzzer, scoring, and reveal animations included.",
    techStack: ["React", "Create React App", "use-sound", "GitHub Pages"],
    liveUrl: "https://himekatie.github.io/ComedyFeud/",
    githubUrl: "https://github.com/himekatie/ComedyFeud",
    photos: [Comedyfued1, Comedyfued2, Comedyfued3, Comedyfued4, Comedyfued5],
  },
  {
    slug: "urbanvoice",
    title: "Urbanvoice",
    tag: "HackRPI 2024",
    thumbnail: Urban1,
    description: "A hackathon project giving city residents a louder, more organized voice on local issues that affect their neighborhoods. We didn't get to finish the project, but we did a lot of research and prototyping to get to a prototype that we were proud of. We had issues with our live demo.",
    techStack: ["React", "JavaScript", "Python", "HTML", "CSS"],
    liveUrl: "",
    githubUrl: "https://github.com/SujiChen/urbanvoice",
    photos: [Urban1, Urban2, Urban3, Urban4, Urban5, Urban6, Urban7, Urban8],
  },
  {
    slug: "choose-your-own-adventure",
    title: "Choose Your Own Adventure",
    tag: "HackRPI 2023",
    thumbnail: choose1,
    description: "An interactive, branching-narrative game where every choice you make rewrites the story ahead. This was my first hackathon project, and I learned a lot about working with a team and building a project from scratch in a short amount of time. This was also my first website project, and I learned a lot about web development and the basics of website buidling.",
    techStack: ["HTML", "JavaScript", "GitHub Pages"],
    liveUrl: "https://himekatie.github.io/ChooseYourOwnAdventure/",
    githubUrl: "https://github.com/himekatie/ChooseYourOwnAdventure",
    photos: [choose1, choose2, choose3, choose4, choose5, choose6, choose7],
  },
  {
    slug: "budgetscout",
    title: "BudgetScout",
    tag: "Software Design & Documentation 2026",
    thumbnail: budget1,
    description: "A full software design and documentation project for a personal budgeting app, completed for a Software Engineering course. The class was structured in three stages: first, translating a real-world problem into a clear, feasible proposed solution; second, transforming that proposal into diagrams and documentation precise enough for a development team to collaborate from; and third, working with a team to implement the design and validate through testing that it actually solved the original problem. My focus was on the requirements and system design phase - defining user needs, architecting the system, and producing documentation that could hand off cleanly to implementation.",
    techStack: ["React Native", "Expo", "iOS", "Android"],
    liveUrl: "",
    githubUrl: "https://github.com/SujiChen/BudgetScout",
    photos: [budget1, homepage, recording, catalog1],
  },
];